import React from 'react';
import EqualHeightComponent from '@bbkPricingPage/components/equal-height-component/equal-height-component';
import RenderAlignedHtml from './aligned-html-render';

type InfoTextProps = {
  ignoreEqualHeight: boolean;
  infoText: string;
};

const InfoText: React.FC<InfoTextProps> = ({ ignoreEqualHeight, infoText }) => {
  return (
    <EqualHeightComponent
      groupId="dynamic-height-pricing-card-info-text"
      ignore={ignoreEqualHeight}
    >
      <div className="tw-mt-2 tw-text-center tw-text-xs tw-text-[color-mix(in_srgb,var(--pricing-page-text-font-text-color)_85%,transparent)]">
        <RenderAlignedHtml value={infoText} />
      </div>
    </EqualHeightComponent>
  );
};

export default InfoText;
